<template>
    <div :class="{ 'sw-form-section': edit }">
        <div v-if="edit" class="sw-mb-1">
            <i @click="$emit('delete')" class="fa fa-trash sw-pointer sw-mr-half"></i>
            <i @click="$emit('edit')" class="fa fa-pen sw-pointer"></i>
        </div >
        <div>
            <div class="sw-index sw-flex sw-container sw-mb-1">
                {{ title }}
            </div>
            <div v-if="windowWidth>=768" class="sw-scala sw-container">

                <div v-for="(answer, index) in answers" :id="`${id}_option_${index}`" class="sw-flex sw-align-center">
                    <input :value="answer.value" @input="$emit('input:checked', {id: id, value: $event.target.value})" class="sw-radio form-radio sw-mr-1"
                           type="radio" :name="id"/>
                    <div> {{ answer.text }}</div>
                </div>


                <!--                <div class="sw-flex sw-mr-2 sw-flex-grow sw-justify-between sw-mb-2 sw-mt-2">-->
                <!--                    <div v-for="(index) in parseInt(3)" :id="`${id}_option_${index}`" class="sw-flex sw-align-center">-->
                <!--                        <input :value="index" @input="$emit('input:checked', {id: id, value: $event.target.value})" class="sw-radio form-radio sw-mr-1"-->
                <!--                               type="radio" :name="id"/>-->
                <!--                        <div class="sw-index"> {{ index }}</div>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>
            <div v-else class="sw-scala sw-container sw-flex-center sw-block">

                <div v-for="(answer, index) in answers" :id="`${id}_option_${index}`" class="sw-flex sw-align-center">
                    <input :value="answer.value" @input="$emit('input:checked', {id: id, value: $event.target.value})" class="sw-radio form-radio sw-mr-1"
                           type="radio" :name="id"/>
                    <div class="sw-index"> {{ answer.text }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Input from "@/Pages/Forms/Partials/Input.vue";

export default {
    name: "MultipleChoice",
    components: {Input},
    props: {
        edit: Boolean,
        component: Object,
        id: {
            type: [String, Number],
            required: true
        },
        title: {
            type: String,
            default: 'Titel'
        },
        answers: {
            type: Array,
            required: true
        },
        answersCount: {
            type: [String, Number],
            default: 5
        }
    },
    data() {
        return{
            windowWidth:window.innerWidth
        }
    },
    mounted() {
        window.onresize =()=>{
            this.windowWidth = window.innerWidth;
        };
    },
    computed: {
        isHidden() {
            return this.component?.settings?.hidden === true;
        }
    }
}
</script>

<style scoped>

</style>
